<template>
	<div class="column is-3 is-hidden-touch">
		<div class="left side">
			<div v-for="(item,index) in left_list" :key="index">
				<a class="toZhanlan left__item" :class="left_nav_on==item.cate_code?'is-current':''" @click="click_left_nav(item.cate_code)">{{item.cate_name}}</a>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'header_html',
	props: {
		left_list: {
			type: Array,
			default:()=>[],
		},
	},
	data() {
		return {
			left_nav_on:'',
		}
	},
	mounted() {
		// this.init();
		window.addEventListener("scroll", this.scrolling);
	},
	beforeDestroy() {
		window.removeEventListener("scroll", this.scrolling);
	},
	methods: {
		init(){
			this.left_nav_on=this.left_list[0].cate_code;
			this.$nextTick(()=>{
				var top2 = document.body.scrollTop||document.documentElement.scrollTop 
				for (var i = 0; i < this.left_list.length; i++) {
					var dom=this.$parent.$refs[this.left_list[i].cate_code];
					if(dom.length){
						var rect = dom[0].getBoundingClientRect();
					}else{
						var rect = dom.getBoundingClientRect();
					}
					var scrollTop = rect.top+top2;
					this.left_list[i].top=scrollTop
				}
			})
		},
		scrolling(){
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			for (var i = 0; i < this.left_list.length; i++) {
				if(scrollTop > (this.left_list[i].top-10)){
					this.left_nav_on=this.left_list[i].cate_code;
				}
			}
		},
		click_left_nav(name){
			var scrollTop=-1;
			for (var i = 0; i < this.left_list.length; i++) {
				if(name==this.left_list[i].cate_code){
					scrollTop = this.left_list[i].top;
					break
				}
			}
			if(scrollTop!=-1){
				document.documentElement.scrollTop = scrollTop;
			}
		},
	}
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/left_list.vue